/* @flow */

import * as types from 'src/shared/domain/topic/action/topicActionTypes';
import {
  createReducer,
  setFetchingState,
  unsetFetchingState,
} from 'src/shared/core/util/reducerUtils';

const initialState = {
  isFetching: false,
};

export default createReducer(initialState, {
  [types.FETCH_IS_TOPIC_BOOKABLE_REQUEST]: setFetchingState,
  [types.FETCH_IS_TOPIC_BOOKABLE_SUCCESS]: unsetFetchingState,
  [types.FETCH_IS_TOPIC_BOOKABLE_FALIURE]: unsetFetchingState,
});
